import { useEffect, useState } from "react";
import { ZoomIn, ZoomOut, X, ExternalLink } from "lucide-react";
import { fotoUrl } from "./util";

export const FotoZoom = ({ src, onClose }) => {
  const [z, setZ] = useState(1);
  useEffect(() => {
    const k = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", k);
    return () => window.removeEventListener("keydown", k);
  }, [onClose]);
  return (
    <div className="fixed inset-0 z-[60] bg-black/85 flex flex-col" data-testid="foto-zoom" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="flex items-center gap-2 p-2 text-white">
        <button onClick={() => setZ(Math.max(0.5, z - 0.5))} className="rounded bg-white/15 p-2" data-testid="foto-zoom-menos"><ZoomOut className="w-5 h-5" /></button>
        <span className="text-sm tabular-nums w-12 text-center">{Math.round(z * 100)}%</span>
        <button onClick={() => setZ(Math.min(5, z + 0.5))} className="rounded bg-white/15 p-2" data-testid="foto-zoom-mas"><ZoomIn className="w-5 h-5" /></button>
        <a href={fotoUrl(src)} target="_blank" rel="noreferrer" className="rounded bg-white/15 p-2" data-testid="foto-zoom-original"><ExternalLink className="w-5 h-5" /></a>
        <button onClick={onClose} className="ml-auto rounded bg-white/15 p-2" data-testid="foto-zoom-cerrar"><X className="w-5 h-5" /></button>
      </div>
      <div className="flex-1 overflow-auto p-2" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
        <img src={fotoUrl(src)} alt="" style={{ width: `${z * 100}%`, maxWidth: "none" }} className="mx-auto block" />
      </div>
    </div>
  );
};

// Fotografía completa y grande, visible sin desplegar; clic para ampliar más.
export const FotoGrande = ({ src, testid, onQuitar }) => {
  const [zoom, setZoom] = useState(false);
  return (
    <div className="relative rounded-lg border bg-zinc-50 p-1" data-testid={testid}>
      <img src={fotoUrl(src)} alt="" onClick={() => setZoom(true)} className="w-full h-auto max-h-[720px] object-contain cursor-zoom-in" />
      <button onClick={() => setZoom(true)} className="absolute top-2 right-2 rounded-full bg-zinc-900/80 text-white p-1.5" data-testid={`${testid}-ampliar`}><ZoomIn className="w-4 h-4" /></button>
      {onQuitar && <button onClick={onQuitar} className="absolute top-2 left-2 rounded-full bg-red-600 text-white p-1.5" data-testid={`${testid}-quitar`}><X className="w-4 h-4" /></button>}
      {zoom && <FotoZoom src={src} onClose={() => setZoom(false)} />}
    </div>
  );
};
